import { ChangeDetectorRef, Component, Input } from '@angular/core';

import { ModalService } from "pf_styleguide";

@Component({
    selector: 'mlp-venue-content-modal',
    templateUrl: './venue-content-modal.component.html',
    styleUrls: ['./venue-content-modal.component.scss']
})

export class VenueContentModalComponent {
    @Input() hideFooter:boolean;
    constructor(public modService: ModalService, public cd:ChangeDetectorRef) {
    }
    
}
